export default {
  harvestTypes: [],
  loading: false
}
